import { render, staticRenderFns } from "./ProjectDetailsOverlay.vue?vue&type=template&id=ab1a5376&scoped=true&"
import script from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailsOverlay.vue?vue&type=style&index=0&id=ab1a5376&prod&scoped=true&lang=css&"
import style1 from "./ProjectDetailsOverlay.vue?vue&type=style&index=1&id=ab1a5376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1a5376",
  null
  
)

export default component.exports